/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-04 10:03:45
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Button, Heading } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { routes } from 'src/routes';
import history from 'src/routes/history';

import empty from 'src/assets/images/filter-tree/empty-option.png';

type Props = WithI18nProps;
// DONE
class NoWidgetFound extends Component<Props> {
  render() {
    const { i18n, isSearch, isFilter, selectedTab } = this.props;
    let text1Key = 'noSearchResultAllPage_Content1';
    let text2Key = 'noSearchResultAllPage_Content2';
    if (!isSearch && !isFilter) {
      switch (selectedTab) {
        case 0: {
          text1Key = 'noWidget_Tab0_Content1';
          text2Key = 'noWidget_Tab0_Content2';
          break;
        }
        case 1: {
          text1Key = 'noWidget_Tab1_Content1';
          text2Key = 'noWidget_Tab1_Content2';
          break;
        }
        case 2: {
          text1Key = 'noWidget_Tab2_Content1';
          text2Key = 'noWidget_Tab2_Content2';
          break;
        }
        default:
      }
    }

    return (
      <div className="BC-EmptySearch__RecommendationWidget">
        <img src={empty} alt={i18n.translate('AdminHTML.ProductRanking.NoProductRanking.imgAlt')} />
        <Heading>{i18n.translate(`AdminHTML.Recommendation.WidgetDashboard.${text1Key}`)}</Heading>
        <p style={{ margin: '4px 0 24px' }}>
          {i18n.translate(`AdminHTML.Recommendation.WidgetDashboard.${text2Key}`)}
        </p>
        {!isFilter && !isSearch && selectedTab in [0, 1] && (
          <Button
            primary
            onClick={() => {
              history.push(routes.recommendationWidgets.new());
            }}>
            {i18n.translate('AdminHTML.Recommendation.Common.buttonAddNew')}
          </Button>
        )}
        <div style={{ padding: '40px' }} />
      </div>
    );
  }
}

export default withI18n()(NoWidgetFound);
